import {Component} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListQuoteStandardWrapperComponent } from '@app/pages/quote/standard-quote/list-quote-standard/list-quote-standard-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-list-quote-standard-mobile',
  templateUrl: './list-quote-standard-mobile.component.html',
  styleUrls: ['./list-quote-standard-mobile.component.scss'],
})
export class ListQuoteStandardMobileComponent extends ListQuoteStandardWrapperComponent {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
